import { ChevronRight } from 'lucide-react';
import { Link } from 'react-router-dom';

interface ArticleCardProps {
  title: string;
  path: string;
  fromRole?: string;
}

export function ArticleCard({ title, path, fromRole }: ArticleCardProps) {
  const to = fromRole ? `${path}?from=${fromRole}` : path;

  return (
    <Link
      to={to}
      className='group flex items-center gap-3 rounded-lg border border-border bg-white px-4 py-3.5 transition-colors hover:border-primary'
    >
      <span className='text-sm text-text transition-colors group-hover:text-primary'>{title}</span>
      <ChevronRight size={16} className='ml-auto shrink-0 text-[#C0C0C0]' />
    </Link>
  );
}
